import React from "react";
import ReactDOM from "react-dom";
import { Settings as SlickSettings } from "react-slick";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { BREAKPOINTS } from "web/react/constants";
import { Image } from "web/react/pages/product/product-image-gallery/product-gallery-image";
import { ProductImageGalleryCarouselEmo } from "web/react/pages/product/product-image-gallery/product-image-carousel-emo";
import { ImageChangeEventSource } from "web/react/pages/product/product-image-gallery/product-image-gallery";
import * as styles from "web/react/pages/product/product-image-gallery/product-image-gallery.css";
import { ProductCardSerializer } from "web/types/serializers";

interface FullscreenGalleryEmoProps {
    onClose: () => void;
    images: Image[];
    isOpen?: boolean;
    moreLikeThisProducts?: ProductCardSerializer[];
    currentLinkId?: string;
    currentSlideIndex: number;
    onSlideChange: (src: ImageChangeEventSource, nextSlide: number) => void;
    onSwipe: (direction: "left" | "right") => void;
    isInStockProductPage?: boolean;
}

interface ModalProps {
    children: React.ReactNode;
    onClose: () => void;
    in: boolean;
}

function ModalEmo({ children, onClose }: ModalProps): JSX.Element {
    return ReactDOM.createPortal(
        <div className={styles.overlay} data-testid="fullscreen-gallery">
            <div onClick={onClose} className={styles.close}>
                <SVGIcon name={"cross-thin"} />
            </div>
            {children}
        </div>,
        document.body
    );
}

function FullscreenGalleryEmo({
    isOpen = false,
    onClose,
    images,
    currentSlideIndex,
    onSlideChange,
    onSwipe,
    isInStockProductPage = false,
}: FullscreenGalleryEmoProps): React.ReactElement {
    // Slick settings and props for the fullscreen gallery
    const slickSettings: SlickSettings = {
        accessibility: true,
        speed: 500,
        slidesToShow: 1,
        dots: images.length > 1,
        initialSlide: currentSlideIndex,
        centerMode: false,
        touchThreshold: 5,
        infinite: false,
        swipeToSlide: true,
        arrows: false,
        swipe: true,
        onSwipe: onSwipe,
        touchMove: false,
        draggable: false,
        responsive: [
            {
                breakpoint: BREAKPOINTS.Medium,
                settings: {
                    speed: 200,
                    touchMove: true,
                    draggable: true,
                },
            },
        ],
    };

    return (
        <ModalEmo onClose={onClose} in={isOpen}>
            <ProductImageGalleryCarouselEmo
                images={images}
                isFullscreen={true}
                settings={slickSettings}
                onClose={onClose}
                currentSlideIndex={currentSlideIndex}
                isInStockProductPage={isInStockProductPage}
                onSlideChange={onSlideChange}
            />
        </ModalEmo>
    );
}

export default FullscreenGalleryEmo;
